import React, {Component} from 'react';

import './layout.scss';

class Layout extends Component {
  render(props) {
    return (
      <div className="layout-main">
        { this.props.children }
      </div>
    )
  }
}

export default Layout;